import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import {
    Router
} from '@angular/router';
import {ToastController} from '@ionic/angular';
import {Injectable, OnInit} from '@angular/core';
import {AuthService} from '../services/auth/auth.service';
import {ErrorsMessages} from '../messages/errors/errors-messages';
import {AlertService} from '../services/alert/alert.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(private router: Router,
                public auth: AuthService,
                private alertService: AlertService,
                public toastController: ToastController) {
        alertService.okButtonCallBack = () => {
        };
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.auth.token && this.auth.token.length > 0) {
            request = request.clone({
                setHeaders: {
                    'Authorization': this.auth?.token,
                }
            });
        } else {
            if (!request.url.includes('auth') &&
                !request.url.includes('province') && !request.url.includes('city')) {
                this.router.navigate(['/login']).then();
            }
        }

        if (this.auth.currentPackageInfo && Object.keys(this.auth.currentPackageInfo).length > 0) {
            request = request.clone({
                setHeaders: {
                    'x-package': this.auth.currentPackageInfo && this.auth.currentPackageInfo.id ? this.auth.currentPackageInfo.id : null,
                }
            });
        }

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                this.handleError(error.status);
                return throwError(error);
            }));
    }

    handleError(errorNumber: number) {
        let route: string = '';
        let hasError: boolean = false;
        switch (errorNumber) {
            case 401:
                route = `/errors/401/${ErrorsMessages.error401}`;
                this.auth.forceLogout().then();
                hasError = true;
                break;
            // case 403:
            //     // this.alertService.alert(ErrorsMessages.error403, ErrorsMessages.errorTitle).then();
            //     route = `/errors/403/${ErrorsMessages.error403}`;
            //     hasError = true;
            //     break;
            case 500:
                // this.alertService.alert(ErrorsMessages.error500, ErrorsMessages.errorTitle).then();
                route = `/errors/500/${ErrorsMessages.error500}`;
                hasError = true;
                break;
            // case 502:
            //     // this.alertService.alert(ErrorsMessages.error504, ErrorsMessages.errorTitle).then();
            //     route = `/errors/504/${ErrorsMessages.error502}`;
            //     hasError = true;
            //     break;
            // case 504:
            //     // this.alertService.alert(ErrorsMessages.error504, ErrorsMessages.errorTitle).then();
            //     route = `/errors/504/${ErrorsMessages.error504}`;
            //     hasError = true;
            //     break;
            case 404:
                // this.alertService.alert(ErrorsMessages.error404, ErrorsMessages.errorTitle).then();
                route = `/errors/404/${ErrorsMessages.error404}`;
                hasError = true;
                break;
        }
        if (hasError) {
            this.router.navigate([route]).then();
        }
    }

    async presentToast(msg) {
        const toast = await this.toastController.create({
            message: msg,
            duration: 2000,
            position: 'top'
        });
        toast.present().then();
    }
}
